export const UserRoles = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
}
